module.exports = __webpack_public_path__ + "img/envergonhada.8e47a707.png";